<template>
    <div class="product-form-cart">

        <div class="product-form-price">
            <div class="product-price">
                Итого: <b>{{ formattedPrice }}</b> руб
            </div>
        </div>

        <div class="product-form-btns">
            <a href="#" class="product-buy-btn btn btn-full" @click.prevent="modalBuy()">
                <svg width="18" height="20">
                    <use xlink:href="#icon-cart"></use>
                </svg>
                <span>Купить</span>
            </a>
            <a href="#" class="product-cart-btn" @click.prevent="modalAdd()">
                Добавить в корзину<br> и продолжить покупки
            </a>
        </div>

    </div>
</template>

<!--suppress JSUnresolvedFunction -->
<script>
export default {
    name: "ElementPrice",
    props: {
        basePrice: {
            type: Number,
            default: 0,
        },
        meterQuantity: {
            type: Number,
            default: 0,
        }
    },
    data() {
        if(this.meterQuantity){
           return {
                price: this.basePrice * this.meterQuantity ,
            }
        } else {
            return {
                price: this.basePrice ,
            }
        }

    },
    computed: {
        formattedPrice() {
            return Intl.NumberFormat('ru-RU').format(this.price);
        }
    },
    mounted() {
        VueEventBus.$on('element|set-price', (newPrice) => {
            this.price = newPrice;
        });
    },
    methods: {
        modalBuy() {
            VueEventBus.$emit('element|send-buy');
        },
        modalAdd() {
            VueEventBus.$emit('element|send-add');
        }
    }
}
</script>

<style scoped>

</style>